import React from 'react';
import {
	ActionCard,
	Paragraph,
	Skeleton,
	tokens,
} from '@welbe/web-design-system';
import { FiEdit, FiPlus } from 'react-icons/fi';
import { IItems } from '../../ListJobProfile.hooks';
import { CardsContainer, Container } from './Content.styles';
import { JobProfileType } from 'Views/JobProfile/JobProfile.enums';

interface ContentProps {
	jobProfileType: JobProfileType;
	icon: string;
	title: string;
	subTitle: string;
	description?: string;
	items: IItems[];
	isLoading: boolean;
	handleNewJobProfile: (jobProfileType: JobProfileType) => void;
	handleEditJobProfile: (jobProfileType: JobProfileType, id: string) => void;
}

export const Content = ({
	jobProfileType,
	icon,
	title,
	subTitle,
	description,
	items,
	isLoading,
	handleNewJobProfile,
	handleEditJobProfile,
}: ContentProps) => {
	return (
		<Container>
			<img
				src={icon}
				alt={
					jobProfileType === JobProfileType.RISK_PROFILE
						? 'Perfiles de puesto'
						: 'Area de exposición'
				}
				width={'70px'}
			/>
			<Paragraph fontWeight="600">{title}</Paragraph>
			<Paragraph>{subTitle}</Paragraph>
			<Paragraph fontSize="13px">{description}</Paragraph>
			<CardsContainer>
				<ActionCard
					icon={
						<img
							src={icon}
							alt={
								jobProfileType === JobProfileType.RISK_PROFILE
									? 'Nuevo perfil de riesgo'
									: ' Nueva área de exposición'
							}
							width={'30px'}
						/>
					}
					title={
						jobProfileType === JobProfileType.RISK_PROFILE ? 'Nuevo' : 'Nueva'
					}
					description={
						jobProfileType === JobProfileType.RISK_PROFILE
							? 'Perfil de riesgo'
							: 'Área de exposición'
					}
					action={<FiPlus color={tokens.color_primary} size={20} />}
					onClick={() => handleNewJobProfile(jobProfileType)}
				/>
				{isLoading ? (
					<>
						<Skeleton height="80px" width="260px" />
					</>
				) : (
					<>
						{items.map((item: any) => (
							<ActionCard
								key={item.id}
								icon={
									<img
										src={icon}
										alt={
											jobProfileType === JobProfileType.RISK_PROFILE
												? 'Editar perfil de riesgo'
												: 'Editar área de exposición'
										}
										width={'30px'}
									/>
								}
								title={item.name}
								description={item.description}
								action={<FiEdit color={tokens.color_primary} size={18} />}
								onClick={() => handleEditJobProfile(jobProfileType, item.id)}
							/>
						))}
					</>
				)}
			</CardsContainer>
		</Container>
	);
};
